// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8b2c0c7e","453":"e2360db7","653":"742674b8","745":"2331efd6","800":"ec607c4c","964":"31529052"}[chunkId] + ".chunk.js";
};